module.exports = {"450328100":"龙胜镇","450328101":"瓢里镇","450328102":"三门镇","450328103":"龙脊镇","450328104":"平等镇","450328201":"泗水乡","450328202":"江底乡","450328203":"马堤乡","450328204":"伟江乡","450328206":"乐江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450328.json
// module id = 2104
// module chunks = 0